import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorDialogJarComponent } from './error-dialog-jar.component';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { ClipboardModule } from 'ngx-clipboard';



@NgModule({
  declarations: [ ErrorDialogJarComponent ],
    exports: [
      ErrorDialogJarComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    ClipboardModule  ]
})
export class ErrorDialogJarModule { }
